import { disallow } from 'feathers-hooks-common';
import { validateSchema } from 'straightline-utils/hooks';

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [validateSchema],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
